/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Partner } from './Partner';
import {
    PartnerFromJSON,
    PartnerFromJSONTyped,
    PartnerToJSON,
    PartnerToJSONTyped,
} from './Partner';

/**
 * 
 * @export
 * @interface SaleOrder
 */
export interface SaleOrder {
    /**
     * 
     * @type {number}
     * @memberof SaleOrder
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SaleOrder
     */
    name: string;
    /**
     * 
     * @type {Partner}
     * @memberof SaleOrder
     */
    partnerId: Partner;
}

/**
 * Check if a given object implements the SaleOrder interface.
 */
export function instanceOfSaleOrder(value: object): value is SaleOrder {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('partnerId' in value) || value['partnerId'] === undefined) return false;
    return true;
}

export function SaleOrderFromJSON(json: any): SaleOrder {
    return SaleOrderFromJSONTyped(json, false);
}

export function SaleOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaleOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'partnerId': PartnerFromJSON(json['partner_id']),
    };
}

export function SaleOrderToJSON(json: any): SaleOrder {
    return SaleOrderToJSONTyped(json, false);
}

export function SaleOrderToJSONTyped(value?: SaleOrder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'partner_id': PartnerToJSON(value['partnerId']),
    };
}

